import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { ReactNode } from "react";

interface ProtectedRouteProps {
    children: ReactNode
}

const ProtectedRoute : React.FC<ProtectedRouteProps> = ({children}) => {
    const {isAuthenticated} = useAuth()

    if (!isAuthenticated) {
        return <Navigate to="/login"/>
    }

    return <>{children}</>
}

export default ProtectedRoute